import type { JSX } from 'react';

import { Chip, Text } from '@change/ds-core-ui';
import { FacebookRegularIcon as FacebookIcon, RedditIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

export type Platform = 'reddit' | 'facebook';

type ChipsContainerProps = {
	activeFilter: 'all' | Platform;
	onFilterClick: (platform: 'all' | Platform) => void;
	showChips: Platform[];
};

export function ChipsContainer({ activeFilter, onFilterClick, showChips }: ChipsContainerProps): JSX.Element | null {
	if (showChips.length === 0) return null;

	return (
		<div className="flex flex-row gap-3" data-testid="platform-chips" data-qa="platform-chips">
			{showChips.length === 2 && (
				<Chip
					data-testid="all-chip"
					data-qa="all-chip"
					as="button"
					size="small"
					onClick={() => onFilterClick('all')}
					active={activeFilter === 'all'}
					data-active={activeFilter === 'all' ? 'true' : 'false'}
				>
					<Text>
						<Translate value="corgi.petition.starter_dashboard_v2.recommendations.all.chip_title" />
					</Text>
				</Chip>
			)}
			{showChips.includes('reddit') && (
				<Chip
					data-testid="reddit-chip"
					data-qa="reddit-chip"
					as="button"
					size="small"
					onClick={() => onFilterClick('reddit')}
					active={activeFilter === 'reddit'}
					data-active={activeFilter === 'reddit' ? 'true' : 'false'}
				>
					<div className="flex items-center justify-center gap-1.5">
						<div className="flex h-6 w-6 items-center justify-center rounded-full bg-[#FF6A33] text-white">
							<RedditIcon size="x-small" />
						</div>
						<Text>
							<Translate value="corgi.petition.starter_dashboard_v2.recommendations.reddit.chip_title" />
						</Text>
					</div>
				</Chip>
			)}
			{showChips.includes('facebook') && (
				<Chip
					data-testid="facebook-chip"
					data-qa="facebook-chip"
					as="button"
					size="small"
					onClick={() => onFilterClick('facebook')}
					active={activeFilter === 'facebook'}
					data-active={activeFilter === 'facebook' ? 'true' : 'false'}
				>
					<div className="flex items-center justify-center gap-1.5">
						<div className="flex h-6 w-6 items-center justify-center rounded-full text-[#1877F2]">
							<FacebookIcon size="medium" />
						</div>
						<Text>
							<Translate value="corgi.petition.starter_dashboard_v2.recommendations.facebook.chip_title" />
						</Text>
					</div>
				</Chip>
			)}
		</div>
	);
}
